import { ActionType } from './';

const defaultState = {
  menuItems: null,
  right: 0,
  show: false,
  showMenu: false,
  toggle: () => {} //tslint:disable-line
};

const menu = (state: any = defaultState, action: ActionType) => {
  switch (action.type) {
    case 'SHOW_MENU_ITEMS':
      return {
        ...state,
        menuItems: action.menuItems,
        right: action.right,
        show: true,
      };
    case 'CLOSE_MENU_ITEMS':
      return {
        ...state,
        menuItems: null,
        right: 0,
        show: false
      }
    case 'TOGGLE_MENU':
      return {
        ...state,
        toggle: action.toggle,
      }

    default:
      return state
  }
}

export default menu;



// WEBPACK FOOTER //
// ./src/reducers/menu.ts